import { LoginLayout } from "../layouts";
import { Login as LoginForm } from "../containers";
import { Link } from "react-router-dom";
import ROUTES from "../../application/utils/Routes";

const Login = () => {

    return (

        <div className="p-3">
            <LoginLayout>
                <LoginForm />

                <div className="flex justify-center items-center mt-4">
                    <p className="text-sm text-gray-500">Forgot your password? <Link to={ROUTES.RESESTPASSWORDEMAIL} className="text-blue-500 hover:text-blue-700">Reset</Link></p>
                </div>
            </LoginLayout>
        </div>



    )

}


export default Login;